import { Fragment, useEffect, useState } from "react";
import { Alert, Box, Stack, Typography } from "@mui/material";
import Dropzone from "react-dropzone";
import { humanFileSize } from "utils/file.util";

export default function FormikFileInput({
  handleChange,
  error,
  touched,
  helperText,
  name,
  value,
  alertProps = {},
  ...otherProps
}) {
  const [isTouched, setIsTouched] = useState(false);

  useEffect(() => {
    if (touched === undefined) {
      setIsTouched(true);
    } else {
      setIsTouched(!!touched);
    }
  }, [touched]);
  return (
    <Dropzone onDrop={handleChange} {...otherProps}>
      {({ getRootProps, getInputProps }) => (
        // <Alert
        //   icon={isTouched && error != null}
        //   severity={isTouched && error != null ? "error" : "info"}
        //   {...alertProps}
        // >
        <Box
          {...getRootProps()}
          minWidth="100%"
          sx={({ palette, shape }) => ({
            borderWidth: "1px",
            borderStyle: "dashed",
            borderColor:
              isTouched && error != null
                ? palette.error.main
                : palette.primary.main,
            color:
              isTouched && error != null
                ? palette.error.main
                : palette.primary.main,
            borderRadius: `calc(${shape.borderRadius}px * 1.5)`,
            cursor: "pointer",
          })}
        >
          <input {...getInputProps()} />
          <Box component="ul" minWidth="100%">
            {value != null && Array.isArray(value) && value.length > 0 ? (
              <Fragment>
                <Typography component="div" variant="h5">
                  Selected File{value.length > 1 ? "s" : ""}:
                </Typography>
                {value.map((file) => (
                  <Stack direction="row" component="li" key={file.name}>
                    <Typography
                      component="div"
                      variant="body2"
                      noWrap
                      sx={{ flex: 9 }}
                    >
                      {file.name}
                    </Typography>
                    <Typography
                      component="div"
                      variant="body2"
                      noWrap
                      sx={{ flex: 3 }}
                    >
                      {humanFileSize(file.size)}
                    </Typography>
                  </Stack>
                ))}
              </Fragment>
            ) : helperText != null ? (
              helperText
            ) : (
              <Typography>
                "Drag 'n' drop some files here, or click to select files"
              </Typography>
            )}
            {isTouched && error != null && <Typography>{error}</Typography>}
          </Box>
        </Box>
        // </Alert>
      )}
    </Dropzone>
  );
}
